const COUNTRY_KEY = 'lighthouse_country';

export const DEFAULT_COUNTRY = 'NGA';

export const COUNTRY_CURRENCY: Record<string, string> = {
  NGA: 'NGN',
  GHA: 'GHS',
  CIV: 'XOF',
};

export function getCountryCode(): string {
  if (typeof localStorage === 'undefined') return DEFAULT_COUNTRY;
  return localStorage.getItem(COUNTRY_KEY) || DEFAULT_COUNTRY;
}

export function setCountryCode(code: string): void {
  localStorage.setItem(COUNTRY_KEY, code);
}
